import { ProjectFeedResultAjax } from '@shared/datastore/project-feed';

declare module '../core/backend' {
  interface BackendAjaxFetchTypes {
    projectFeedFailingContests: ProjectFeedResultAjax;
  }
}

export const projectFeedFailingContestsBackend = {
  fetch: () => ({
    endpoint: `navigation/project-feed/pre-populated-xp-projectcontest.php`,
    isGaf: true,
    params: { type: 'c' },
  }),
};



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/project-feed-failing-contests/project-feed-failing-contests.backend.ts